import { useState } from 'react';

import { LogOut, ShoppingCart } from 'lucide-react';
import { useDispatch } from 'react-redux';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { ROUTES } from '../../constants/routes';
import { logoutRequested } from '../../redux/slices/authSlice';
import { IconTab } from '../misc/IconTab';

const FarmshareNavigationTabs = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleLogout = async () => {
    dispatch(logoutRequested());
    navigate(ROUTES.HOME, { replace: true });
  };

  return (
    <div className="mb-8">
      <div className="flex justify-end gap-6 my-4">
        {/* The equipment browse tab is gone with the archived Farmshare page. */}
        <Link to={ROUTES.MY_RESERVATIONS}>
          <IconTab
            icon={ShoppingCart}
            label={t('farmshare.navigationTabs.reservations')}
            selected={location.pathname === ROUTES.MY_RESERVATIONS}
          />
        </Link>
        <IconTab
          icon={LogOut}
          label={t('farmshare.navigationTabs.logout')}
          onClick={handleLogout}
        />
      </div>
      <hr className="border-0 h-[2px] bg-gray300" />
    </div>
  );
};

export { FarmshareNavigationTabs };
